import React, { useState } from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import SvgIcon from '@home/components/SvgIcon';
import GenreFeedbackModal from './Modal';

import type { IBaseProps } from '@intelligence/types/common';
import type { IGenreFeedbackData } from './Modal';

interface IGenreFeedbackProps extends IBaseProps, IGenreFeedbackData { }

const GenreFeedback: React.FC<IGenreFeedbackProps> = (props) => {
  const { entityType, entityId, entityName, isIegg, mainGenre, subGenre, style, className, ...restProps } = props;

  const [visible, setVisible] = useState(false);

  const handleOpen = useMemoizedFn(() => {
    setVisible(true);
  });

  const handleClose = useMemoizedFn(() => {
    setVisible(false);
  });

  return (
    <>
      <SvgIcon
        {...restProps}
        style={style}
        className={classnames('dbi-action-tab-icon', className)}
        type='feedback-entrance'
        onClick={handleOpen}
      />
      <GenreFeedbackModal
        entityType={entityType}
        entityId={entityId}
        entityName={entityName}
        isIegg={isIegg}
        mainGenre={mainGenre}
        subGenre={subGenre}
        visible={visible}
        onClose={handleClose}
      />
    </>
  );
};

export default React.memo(GenreFeedback);
